import { PieChart } from '@mui/x-charts'
import styles from './budgetTrackerStyle.module.scss'
import { useSelector } from "react-redux"

const size = {
	width: 157,
	height: 137,
}

// const data = [
// 	{ value: 25, label: 'Venue', color: '#34464F' }, // dark gray-blue
// 	{ value: 15, label: 'Photography', color: '#587686' }, // teal
// 	{ value: 20, label: 'Food', color: '#7CA6BD' }, // light blue
// 	{ value: 30, label: 'Entertainment', color: '#A7C3D3' }, // pale blue
// 	{ value: 10, label: 'Decor', color: '#D6E3EB' }, // very light blue
// ]

const colors = [
    "#34464F",
    "#3A4D57",
    "#40555F",
    "#465C67",
    "#4C646F",
    "#526B77",
    "#58737F",
    "#5E7A87",
    "#64828F",
    "#6A8997",
    "#70919F",
    "#7698A7",
    "#7CA6BD",
    "#87AECA",
    "#92B7D6",
    "#9DC0E3",
    "#A7C3D3",
    "#B9D3DF",
    "#D6E3EB"
]

export const BudgetAllocation = () => {
    const categoryAllocations = useSelector((s) => s.kazooEvent.categoryAllocations)
    const budget = useSelector((s) => s.kazooEvent.budget)

    const getBudgetAllocationData = () => {
        let data = []
        let usedPercentage = 0
        let idx = 0
        let increment = Math.floor((colors.length - 1) / (Object.keys(categoryAllocations).length - 1))
        for (const key in categoryAllocations){
            let total = 0
            for(const lineItem of categoryAllocations[key]){
                total += lineItem.total
            }
            if(total === 0){
                continue
            }
            
            const percentage = Number((total / budget * 100).toFixed(2))
            data.push({
                value: percentage,
                label: key,
                color: colors[idx]
            })
            idx += increment
            usedPercentage += percentage
        }
        data.push({
            label: 'Unallocated',
            value: 100 - usedPercentage,
            color: '#eaeaeaff'
        })
        return data
    }

    return(
        <>
            <div className={styles.chartWrp}>
                <PieChart
                    series={[
                        {
                            data: getBudgetAllocationData(), // now contains color per slice
                            innerRadius: 45,
                            outerRadius: 65,
                        },
                    ]}
                    {...size}
                    slotProps={{
                        legend: {
                            direction: 'row',
                            position: {
                                vertical: 'bottom',
                                horizontal:
                                    'middle',
                            },
                            // padding: { top: 8 },
                            sx: {
                                mt: 2,
                                '&.MuiChartsLegend-root':
                                    {
                                        gap: '15px',
                                        justifyContent:
                                            'center',
                                    },
                                '& .MuiChartsLegend-mark':
                                    {
                                        width: '8px !important',
                                        height: '8px !important',
                                        borderRadius:
                                            '50%',
                                        marginRight:
                                            '8px',
                                    },
                                '& .MuiChartsLegend-label':
                                    {
                                        fontSize:
                                            '12px',
                                        fontWeight:
                                            '400',
                                        fontFamily:
                                            'Inter',
                                        color: '#8692A4',
                                    },
                                '& .MuiChartsLegend-series':
                                    {
                                        margin: '0',
                                        display:
                                            'flex',
                                        gap: '0',
                                        alignItems:
                                            'center',
                                    },
                            },
                        },
                    }}
                />
            </div>
        </>
    )
}